import { ActivatedRoute } from '@angular/router';
import { AutocompleteInputItem } from '@app/shared/forms/autocomplete-input/autocomplete-input-item';
import { AutoCompleteInputProvider } from '@app/shared/forms/autocomplete-input/autocomplete-input-provider';
import { ViewService } from '@makiwin/ngx-drupal8-rest';
import { Observable, of } from 'rxjs';

export class ProviderDynamicAutoCompleteSchoolTeamByCourse implements AutoCompleteInputProvider {
  private viewService: ViewService;
  private route: ActivatedRoute;
  private members?: AutocompleteInputItem[];

  constructor(viewService: ViewService, route: ActivatedRoute) {
    this.viewService = viewService;
    this.route = route;
    this.fetchTeam();
  }

  filter(term: string): Observable<any> {
    term = term.toLowerCase();
    return of(
      this.members
        ?.filter((item) => item.label.toLowerCase().indexOf(term) > -1)
        .filter((item) => {
          const selectedMembers = (this.viewService as any).storage.scc_school_team.map(
            (m: any) => m.school_member_user
          );
          return selectedMembers.indexOf(item.value) === -1;
        })
    );
  }

  private fetchTeam(): void {
    const nid = this.route.snapshot.paramMap.get('nid') as any;
    this.viewService.get('/api/v1/course_school_members.json', { args: [nid] }).subscribe({
      next: (result) => {
        this.members = result
          .map((item) => ({ value: item.uid, label: item.field_first_name + ' ' + item.field_surname }))
          .sort((a, b) => a.label.toLowerCase().localeCompare(b.label));
      },
    });
  }
}
